import { Grid, Skeleton } from '@purpur/library';
import styled from 'styled-components';

import { getPurpurSpacing, purpurMedia } from '@telialt/common-theme/src/purpurSelectors';

export const SkeletonWrapper = styled(Grid)`
    margin: ${getPurpurSpacing('1000')} auto;

    ${purpurMedia('lg')`
        margin: ${getPurpurSpacing('400')} auto;
    `};
`;

export const DescriptionWrapper = styled(Skeleton)`
    height: ${getPurpurSpacing('1600')};
    margin-bottom: ${getPurpurSpacing('200')};

    ${purpurMedia('lg')`
        height: ${getPurpurSpacing('1600')};
    `};
`;

export const TitleSkeleton = styled(Skeleton)`
    height: ${getPurpurSpacing('600')};

    ${purpurMedia('lg')`
        height: ${getPurpurSpacing('400')};
    `};
`;

export const CompaniesSkeleton = styled(Skeleton)`
    height: ${getPurpurSpacing('600')};

    ${purpurMedia('lg')`
        height: ${getPurpurSpacing('400')}
    `};
`;

export const FacetsSkeleton = styled(Skeleton)`
    height: ${getPurpurSpacing('600')};

    ${purpurMedia('lg')`
        height: 40rem;
    `};
`;
